var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartDrawerIcon = function SvgCartDrawerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D5B68",
    strokeWidth: 1.667,
    d: "M3.334 5.833h13.884l-2.474 8.334H3.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D5B68",
    strokeLinecap: "round",
    strokeWidth: 1.667,
    d: "M.834 2.5h1.52a.98.98 0 0 1 .98.98v2.353"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.334,
    cy: 17.5,
    r: 1.667,
    fill: "#4D5B68"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.167,
    cy: 17.5,
    r: 1.667,
    fill: "#4D5B68"
  })));
};
export default SvgCartDrawerIcon;